<template>
    <div
        v-if="hasFreePlan"
        class="w-full px-[10px]"
        :class="opened ? 'block' : 'hidden xl:block'"
    >
        <div
            class="w-full rounded-[16px] bg-[#0B1220] p-4 text-gray-200 shadow-sm"
        >
            <div class="flex items-center justify-between gap-2">
                <span class="truncate text-[11px] font-medium text-white">
                    {{ t("vue.free_plan_counter_title") }}
                </span>

                <span class="shrink-0 text-[11px] font-medium text-gray-300">
                    {{ freePlanTrackedReports }}
                    {{ t("vue.free_plan_counter_emails_tracked") }}
                </span>
            </div>

            <div class="mt-2 h-3 w-full rounded-full bg-[#2A3344]">
                <div
                    class="h-3 rounded-full transition-all duration-200"
                    :class="freePlanCounterBarColorClass"
                    :style="{
                        width:
                            freePlanCounterProgress > 0
                                ? freePlanCounterProgress + '%'
                                : '2px',
                    }"
                ></div>
            </div>

            <button
                type="button"
                class="mt-3 w-full cursor-pointer rounded-[6.75px] bg-[#088BEA] py-2 text-sm font-semibold text-white hover:bg-[#0A7ED3]"
                @click="handleUpgrade"
            >
                {{ t("vue.free_plan_counter_upgrade_to_scale") }}
            </button>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useTranslations } from "@/composables/useTranslations.ts";

interface IProps {
    opened?: boolean;
    hasFreePlan?: boolean;
    freePlanLastPeriodNumberOfReport?: number | null;
}

const props = withDefaults(defineProps<IProps>(), {
    opened: false,
    hasFreePlan: false,
    freePlanLastPeriodNumberOfReport: 0,
});

const emit = defineEmits<{
    upgrade: [];
}>();

const { t } = useTranslations();

const FREE_PLAN_REPORTS_LIMIT = 5000;

const freePlanTrackedReports = computed(() => {
    const value = Number(props.freePlanLastPeriodNumberOfReport ?? 0);

    if (Number.isNaN(value) === true) {
        return 0;
    }

    return Math.max(0, Math.min(FREE_PLAN_REPORTS_LIMIT, value));
});

const freePlanCounterProgress = computed(() => {
    return (freePlanTrackedReports.value / FREE_PLAN_REPORTS_LIMIT) * 100;
});

const freePlanCounterBarColorClass = computed(() => {
    if (freePlanTrackedReports.value >= 2700) {
        return "bg-[#FF4D4D]";
    }

    if (freePlanTrackedReports.value >= 550) {
        return "bg-[#F9CC44]";
    }

    return "bg-[#04C951]";
});

const handleUpgrade = () => {
    emit("upgrade");
};
</script>
